// extracted by mini-css-extract-plugin
export default {"userFooter":"footer_userFooter__B3sCe","header-title-text":"footer_header-title-text__ODyyq","policy":"footer_policy__rMlYI"};